export const REFERRAL_CODE_QUERY_PARAM = 'ref'
export const REFERRAL_CODE_STORAGE_KEY = 'ref'

export function getStoredReferralCode(): string | null {
  const referralCode = localStorage.getItem(REFERRAL_CODE_STORAGE_KEY)?.trim()
  return referralCode ? referralCode : null
}

export function storeReferralCode(referralCode: string) {
  const trimmedReferralCode = referralCode.trim()
  if (!trimmedReferralCode) return

  localStorage.setItem(REFERRAL_CODE_STORAGE_KEY, trimmedReferralCode)
}

export function clearStoredReferralCode() {
  localStorage.removeItem(REFERRAL_CODE_STORAGE_KEY)
}

export function appendReferralCodeQuery(endpoint: string, referralCode?: string | null): string {
  const trimmedReferralCode = referralCode?.trim()
  if (!trimmedReferralCode) return endpoint

  const separator = endpoint.includes('?') ? '&' : '?'
  return `${endpoint}${separator}referralCode=${encodeURIComponent(trimmedReferralCode)}`
}
